exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-export .modal-body{overflow:visible}.product-export .modal-body .select-container{padding:.5rem 1rem .5rem 1.7rem}.product-export .modal-body .select-container .select-component{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/product/components/productExportModal.scss
// module id = 4828
// module chunks = 0